export default __webpack_public_path__ + "static/media/testimonials.6839a87b.jpeg";